import { FileText } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function CommonFooter() {
  const { t } = useTranslation()

  return (
    <footer className="mx-0 py-0 pt-15 pb-10 md:pt-20 md:pb-15 px-4 text-center text-sm mt-auto">
      <div className="flex items-center justify-center gap-4 mb-2">
        <a
          href="https://github.com/totorofinance/swap-contracts"
          target="_blank"
          rel="noreferrer noopener"
          className="inline-flex items-center gap-1 hover:text-primary transition-colors"
        >
          <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-4 h-4"
            aria-hidden="true"
          >
            <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.385-1.335-1.755-1.335-1.755-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.4 3-.405 1.02.005 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
          </svg>
          {t('about.github')}
        </a>
        <a
          href="/SmartContractAuditCertificate.pdf"
          target="_blank"
          rel="noreferrer noopener"
          className="inline-flex items-center gap-1 hover:text-primary transition-colors"
        >
          <FileText className="w-4 h-4" />
          {t('about.audit')}
        </a>
      </div>
      <p>
        &copy; {new Date().getFullYear()} {t('about.copyright')}{' '}
      </p>
    </footer>
  )
}
